import React from 'react';
import {handleResponse} from '../../ext/common/rest-api-helper';
import {Button} from '@material-ui/core';

type Props = {apiToken: string; user: string; adKey: string}

function getAdUrl(userAuthToken: string, adSubmitter: string, adKey: string): Promise<string> {
  return fetch(`/api/v1/requestfiles/download/${btoa(adSubmitter)}/${adKey}`, {
    headers: {
      Authorization: userAuthToken
    }
  }).then(handleResponse as (_: Response) => Promise<string>);
}

const DownloadAdButton: React.FC<Props> = ({apiToken, user, adKey}: Props) => {
  function handleClick() {
    getAdUrl(apiToken, user, adKey)
      .then(url =>
        window.location.href = url)
      .catch(_ =>
        alert('Unable to download ad file. Try again or contact support.'));
  }


  return (
    <Button
      type="button"
      onClick={handleClick}
    >Download</Button>
  );
}
export default DownloadAdButton;